import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/react/button';

const GiftCardListingItem = ({
  label,
  image,
  imageAltText,
  name,
  purchaseCtaLabel,
  purchaseCtaLink,
  termsAndConditionsCtaLabel,
  termsAndConditionsCtaLink,
  goal
}) => (
  <div className="gift-card-listing-item">
    {label && (
      <div className="gift-card-listing-item__label">
        <span>{label}</span>
      </div>
    )}
    {image && (
      <div className="gift-card-listing-item__image">
        <a href={purchaseCtaLink} rel="noreferrer" target="_blank">
          <img src={image} alt={imageAltText} className="img--cover" />
        </a>
      </div>
    )}
    <h3 className="gift-card-listing-item__name">{name}</h3>
    <div className="gift-card-listing-item__cta-group">
      <Button
        label={purchaseCtaLabel}
        ariaLabel={`${purchaseCtaLabel} ${name}`}
        btnClassName="primary"
        type="link"
        href={purchaseCtaLink}
        rel="noreferrer"
        target="_blank"
        size="small"
        {...(goal
          ? {
              'data-goal': goal.id,
              'data-goal-brand': name
            }
          : {})}
      />
      <a
        href={termsAndConditionsCtaLink}
        target="_blank"
        rel="noreferrer"
        aria-label={`${name} ${termsAndConditionsCtaLabel}`}
      >
        {termsAndConditionsCtaLabel}
      </a>
    </div>
  </div>
);

GiftCardListingItem.propTypes = {
  label: PropTypes.string,
  image: PropTypes.string.isRequired,
  imageAltText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  purchaseCtaLink: PropTypes.string.isRequired,
  purchaseCtaLabel: PropTypes.string.isRequired,
  termsAndConditionsCtaLink: PropTypes.string.isRequired,
  termsAndConditionsCtaLabel: PropTypes.string.isRequired,
  goal: PropTypes.object
};

export default React.memo(GiftCardListingItem);
